<div class="container pb-4 pt-4 ">
  <app-breadcrumb currentRouteName="Foire aux questions"></app-breadcrumb>
  <h1 class="pt-4 d-flex justify-content-between">Foire aux questions
    @if (!search) {
      <app-mobile-search (mobileSearch)="mobileSearch($event)"
      helper="Rechercher un article"></app-mobile-search>
    }
  </h1>

  @if (search) {
    <div class="d-inline-block d-md-none pb-2">
      <div class="d-inline-block">
        <span class="d-flex mobile-search-info">
          {{ search }}
          <fa-icon class="d-block" icon="times" (click)="search = ''; doSearch()"></fa-icon>
        </span>
      </div>
      <span class="text-info">
        {{ articles.length }} résultat(s)
      </span>
    </div>
  }


  @if (error) {
    <div class="text-warning mt-5">
      <fa-icon icon="exclamation-triangle"></fa-icon>
      Le service FAQ est momentanément indisponible
    </div>
  } @else {
    @if (!load) {
      <div>
        <div class="ps-0 col-md-9 d-none d-md-block">
          <app-search-bar [searchVal]="search" (search)="search = $event; doSearch()"></app-search-bar>
        </div>
        <div>
          <div class="d-flex flex-column flex-md-row justify-content-between grid-gap-10">
            <div class="d-flex flex-wrap grid-gap-10">
              @for (cat of categories; track cat) {
                <app-badge class="cursor-pointer hover-badge"
                  [ngClass]="selectedCategory && cat.id !== selectedCategory.id ? 'opacity05' : ''"
                  [label]="{id: cat.id, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"
                (click)="selectCategory(cat)"></app-badge>
              }
            </div>
            @if (articles.length > 0) {
              <div class="d-none d-md-block min14rem text-md-right">
                {{ ((page - 1) * pagesize) + 1 }}-{{ (page * pagesize) | min:articles.length }} sur {{ articles.length }}
                <fa-icon icon="chevron-left" size="lg" class="ms-3 cursor-pointer" [ngClass]="page > 1 ? '': 'disabled'"
                (click)="previousPage()"></fa-icon>
                <fa-icon icon="chevron-right" size="lg" class="ms-3 cursor-pointer"
                [ngClass]="page < articles.length / pagesize ? '': 'disabled'" (click)="nextPage()"></fa-icon>
              </div>
            }
          </div>
          @if (articles.length == 0) {
            <div class="p-3 mt-4">
              Aucun article ne correspond à la recherche.
            </div>
          }
          @for (article of (articles.slice((page - 1) * pagesize, page * pagesize)); track article) {
            <div
              class="faq-block p-3 mt-4 position-relative bg-white cursor-pointer" [routerLink]="'' + article.id">
              <h2 class="d-flex flex-column-reverse d-md-block grid-gap-10 mb-0">{{ article.title.rendered  | urldecode }}
                @for (cid of article.categories; track cid) {
                  <span style="display: contents">
                    @if (getCategoryById(cid); as c) {
                      <app-badge class="me-1 ms-1"
                        [label]="{id: 0, textcolor: c.textcolor, backcolor: c.backcolor, name: c.name}">
                      </app-badge>
                    }
                  </span>
                }
              </h2>
            </div>
          }
        </div>
        @if (articles.length > 0) {
          <div class="d-flex d-md-none justify-content-between mt-3 mb-4">
            <fa-icon icon="chevron-left" size="lg" class="cursor-pointer" [ngClass]="page > 1 ? '': 'disabled'"
            (click)="previousPage()"></fa-icon>
            <span>{{ ((page - 1) * pagesize) + 1 }}-{{ (page * pagesize) | min:articles.length }}
            sur {{ articles.length }}</span>
            <fa-icon icon="chevron-right" size="lg" class="cursor-pointer"
            [ngClass]="page < articles.length / pagesize ? '': 'disabled'" (click)="nextPage()"></fa-icon>
          </div>
        }
        <div class="mt-3 d-none d-md-flex justify-content-end">
          @if (articles.length > 0) {
            <div class="min14rem text-md-right">
              {{ ((page - 1) * pagesize) + 1 }}-{{ (page * pagesize) | min:articles.length }} sur {{ articles.length }}
              <fa-icon icon="chevron-left" size="lg" class="ms-3 cursor-pointer" [ngClass]="page > 1 ? '': 'disabled'"
              (click)="previousPage()"></fa-icon>
              <fa-icon icon="chevron-right" size="lg" class="ms-3 cursor-pointer"
              [ngClass]="page < articles.length / pagesize ? '': 'disabled'" (click)="nextPage()"></fa-icon>
            </div>
          }
        </div>
      </div>
    } @else {
      <ls-spinner></ls-spinner>
    }
  }

</div>
